<template>
  <v-card outlined>
    <table-search @search="v => (search = v)" />
    <v-data-table
      class="mt-5"
      dense
      fixed-header
      :headers="headers"
      :items="palletsLogs"
      item-key="id"
      :items-per-page="15"
      :sort-by="['createdAt']"
      :sort-desc="[true]"
      no-data-text="No Logs Found!"
      no-results-text="No Logs Found!"
      :search="search"
      :loading="pending"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.userName`]="{ item }">
        {{ item.userName }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.creationDate | moment("utc") | moment('YYYY/MM/DD') }} 
        {{ item.creationTime | moment("utc") | moment("hh:mm:ss A") }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import palletsLogsHeaders from '@/models/pallets-logs-headers';

export default {
  name: 'DockLogs',
  data() {
    return { search: '' };
  },
  computed: {
    ...mapState('dock', ['palletsLogs', 'pending']),
    headers: () => palletsLogsHeaders
  }
};
</script>

<style lang="scss" scoped>
.table_search {
  width: 50%;
  @media (min-width: 340px) and (max-width: 767px) {
    width: 60%;
  }
}
</style>
